import { render, staticRenderFns } from "./RegisterMovement.vue?vue&type=template&id=5a5b1a96&scoped=true&"
import script from "./RegisterMovement.vue?vue&type=script&lang=js&"
export * from "./RegisterMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b1a96",
  null
  
)

export default component.exports